import { getColor, getSize } from "views/resources/theme";
import styled from "styled-components";

const Wrapper = styled.div`
	position: relative;
	background-image: linear-gradient(
		50deg,
		${getColor("secondary")},
		${getColor("primary")}
	);
	${(props) => !props.isHeaderVisible && "background-image: none;"};
	height: 210px;
	padding-top: 0px;
`;

const HeaderWrapper = styled.div`
	padding: 4px 16px;
`;

const Title = styled.div`
	font-weight: 700;
	font-size: 1.5rem;
`;

const Subtitle = styled.div`
	font-weight: 500;
	font-size: 1rem;
	color: #595959;
	margin-bottom: 12px;
`;

const Container = styled.div`
	padding: 8px;
`;

export { Wrapper, HeaderWrapper, Subtitle, Container, Title };
